var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelevisits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    enableBackground: "new 0 0 48 48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "s8DAKf.tif"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#006EC5",
    d: "M47.146,24.53c-0.088,3.293-0.963,6.936-2.734,10.384 c-0.354,0.688-0.431,1.698-0.241,2.459c0.576,2.294,1.37,4.532,2.034,6.807c0.494,1.691-0.19,2.417-1.878,1.934 c-2.22-0.639-4.384-1.485-6.622-2.034c-0.858-0.212-1.987-0.117-2.768,0.28c-8.863,4.512-19.053,3.398-26.325-3.292 c-7.126-6.555-9.42-14.793-6.564-23.974c2.878-9.257,9.48-14.762,19.179-15.982C35.124-0.638,47.109,10.044,47.146,24.53z  M16.512,26.931c0.036,0.761,0.075,1.278,0.082,1.794c0.032,2.47,0.192,2.64,2.634,2.642c4.275,0.005,8.553,0.007,12.827,0 c2.19-0.002,2.406-0.227,2.413-2.481c0.008-3.147,0.008-6.294,0.001-9.442c-0.006-2.121-0.246-2.383-2.325-2.392 c-4.099-0.017-8.196-0.008-12.293-0.008c-3.202,0-3.2,0.001-3.249,3.28c-0.006,0.333-0.053,0.666-0.095,1.166 c-1.777-1.008-3.421-1.917-5.042-2.869c-1.175-0.689-1.625-0.298-1.62,0.967c0.01,3.088,0.013,6.175-0.002,9.262 c-0.007,1.52,0.609,1.575,1.751,0.878C13.146,28.781,14.755,27.924,16.512,26.931z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelevisits);
export default __webpack_public_path__ + "static/media/Televisits.f3912a9cabc5294e85b59479fd21734b.svg";
export { ForwardRef as ReactComponent };